<template>
  <vertical-stack>
    <h3 class="heading-small">
      {{ $t(`benefits.heading`) }}
    </h3>
    <ul class="paragraph-content">
      <li>{{ $t(`benefits.bullet1`) }}</li>
      <li>{{ $t(`benefits.bullet2`) }}</li>
      <li>{{ $t(`benefits.bullet3`) }}</li>
      <li>{{ $t(`benefits.bullet4`) }}</li>
      <li>{{ $t(`benefits.bullet5`) }}</li>
    </ul>
    <div class="subtext-content">
      {{ $t(`benefits.subtext`) }}
    </div>
  </vertical-stack>
</template>

<script setup>
import { VerticalStack } from 'ihunter-pathfinder-components';

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

@include Accounts.Default;

.vertical-stack {
  gap: Pathfinder.$space-150;
  margin-bottom: Pathfinder.$space-500;

  @include Pathfinder.below(min) {
    margin-bottom: Pathfinder.$space-400;
  }
}

.paragraph-content {
  padding-inline-start: Pathfinder.$space-300;
}
</style>